import React, { Suspense } from "react";
import { Drawer, Spin } from "antd";
import { useOverlay } from "../../context/OverlayContext";
import {
  getOverlayConfig,
  getOverlayWidth,
} from "../../config/OverlayRegistry";
import "./index.scss";

/**
 * OverlayManager
 *
 * Centralized overlay renderer. Exists EXACTLY ONCE in MainLayout.
 *
 * Rules:
 * - Never render OverlayManager inside pages
 * - Never conditionally mount it
 * - Never create per-entity overlays
 * - Width comes ONLY from OverlayRegistry
 */
const OverlayManager = () => {
  const { isOpen, entity, id, closeOverlay } = useOverlay();

  // Get entity configuration from registry
  const config = entity ? getOverlayConfig(entity) : null;
  const width = entity ? getOverlayWidth(entity) : 800;
  const DetailComponent = config?.component;

  // Handle drawer close
  const handleClose = () => {
    closeOverlay("x");
  };

  return (
    <Drawer
      data-testid="overlay-manager"
      open={isOpen}
      onClose={handleClose}
      width={width}
      placement="right"
      destroyOnClose
      maskClosable={true}
      keyboard={false} // We handle Esc in OverlayContext
      className="overlay-manager-drawer"
      styles={{
        body: { padding: 0 },
        header: { display: "none" },
      }}
    >
      {isOpen && DetailComponent && (
        <Suspense
          fallback={
            <div className="overlay-loading">
              <Spin size="large" />
            </div>
          }
        >
          <div className="overlay-detail">
            <DetailComponent id={id} mode="overlay" close={handleClose} />
          </div>
        </Suspense>
      )}
      {isOpen && !DetailComponent && entity && (
        <div className="overlay-error">
          <p>Unknown entity type: {entity}</p>
        </div>
      )}
    </Drawer>
  );
};

export default OverlayManager;
